import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Warm%20abstract%20community%20connection%20pattern%20with%20flowing%20organic%20shapes%20in%20amber%20and%20olive%20tones%2C%20soft%20gradient%20texture%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20composition%2C%20no%20text&width=1800&height=800&seq=cta-bg-2026&orientation=landscape)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 to-black/45"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始你的社区之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/75 mb-8 leading-relaxed">
          加入蘑菇社区，与18万+兴趣爱好者一起，发现、分享、成长。
          每一次点赞和评论，都是温暖的连接。
        </p>
        <Link
          to="/about"
          className="inline-flex px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          免费加入蘑菇社区
        </Link>
      </div>
    </section>
  );
}